import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.some";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import router, { createRoutesInLayout, resetRouter } from '@/router';
import { generatorsRoutes, routesOutLayout } from '@/router/routes';
import { menuHeader, menuAside } from '@/menu';
import { isNil, cloneDeep } from 'lodash';
var initAuthorityValue = 'store-router-page'; //计算菜单

function filterTree(arr, keys) {
  var newTree = arr.filter(function (x) {
    return keys.some(function (f) {
      return f.authorityValue == x.authorityValue && f.active || x.authorityValue == initAuthorityValue;
    });
  });
  newTree.forEach(function (x) {
    return YL.hasChildren(x) && (x.children = filterTree(x.children, keys));
  });
  return newTree;
} //从接口返回的数据中计算出路由


function getRoutes(menuSource) {
  var newTree = generatorsRoutes.filter(function (x) {
    return menuSource.some(function (f) {
      return f.authorityValue == x.meta.authorityValue && f.active || x.meta.authorityValue == initAuthorityValue;
    });
  });
  return newTree;
}

export default {
  namespaced: true,
  state: {
    menu: [],
    routeKey: [],
    generators: [],
    isLoaded: false
  },
  getters: {
    routeKeyArr: function routeKeyArr(state) {
      return state.routeKey;
    }
  },
  mutations: {
    /**
     * @description 设置动态路由加载状态
     * @param {Object} state state
     * @param {Boolean} value 是否已经加载动态路由
     */
    isLoadedSet: function isLoadedSet(state, value) {
      state.isLoaded = value;
    },

    /**
     * @description 存储权限 - 保存key
     */
    routeKeySet: function routeKeySet(state, flatMenu) {
      state.routeKey = flatMenu.filter(function (x) {
        return x.active;
      }).map(function (m) {
        return m.authorityValue;
      });
    }
  },
  actions: {
    isShowAuto: function isShowAuto(_ref, key) {
      var state = _ref.state;
      console.log(state.routeKey.includes(key));
      return state.routeKey.includes(key);
    },
    setMenu: function setMenu(_ref2) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var state, commit, dispatch, rootState, flatMenu, nMenu, lMenu, pageInit, routes;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                state = _ref2.state, commit = _ref2.commit, dispatch = _ref2.dispatch, rootState = _ref2.rootState;
                // [ 权限 ] 计算权限列表
                flatMenu = YL.flatTreeToArray({
                  data: state.menu || []
                });
                console.log(state.menu); // 取消请求 - 没有登录

                if (rootState.d2admin.account.isLogged) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return");

              case 5:
                if (!state.isLoaded) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return");

              case 7:
                // [ 菜单 ] 计算菜单
                nMenu = [].concat(filterTree(cloneDeep(menuAside), flatMenu));
                lMenu = nMenu.filter(function (x) {
                  return YL.hasChildren(x) || isNil(x['children']);
                }); // [ 菜单 ] 设置顶栏菜单

                commit('d2admin/menu/headerSet', menuHeader, {
                  root: true
                }); // [ 菜单 ] 设置侧边栏菜单

                commit('d2admin/menu/asideSet', lMenu, {
                  root: true
                }); // [ 路由 ] 路由候选

                pageInit = createRoutesInLayout(getRoutes(flatMenu)); // [ 路由 ] 计算路由

                routes = pageInit.concat(routesOutLayout); // [ 路由 ] 重新设置路由

                resetRouter(routes); // [ 路由 ] 重新设置多标签页池

                commit('d2admin/page/init', pageInit, {
                  root: true
                }); // // [ 标签页 ] 重新计算多标签页数据

                dispatch('d2admin/page/openedLoad', {
                  filter: true
                }, {
                  root: true
                }); // // [ 搜索 ] 初始化搜索数据

                commit('d2admin/search/init', nMenu, {
                  root: true
                }); // [ 路由 ] 重新访问
                // if (to) router.replace(to)
                // 标记已经加载过动态路由

                commit('isLoadedSet', true); // 存储权限 - 保存key

                commit('routeKeySet', flatMenu);

              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },

    /**
     * @description 设置路由
     * @param {Object} context
     * @param {String} color 尺寸
     */
    set: function set(_ref3, menu) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var state, dispatch, commit;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                state = _ref3.state, dispatch = _ref3.dispatch, commit = _ref3.commit;
                _context2.next = 3;
                return dispatch('d2admin/db/set', {
                  dbName: 'permission',
                  path: 'permission.menu',
                  value: menu,
                  user: true
                }, {
                  root: true
                });

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },

    /**
     * @description 从持久化数据读取路由设置
     * @param {Object} context
     */
    load: function load(_ref4) {
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var state, dispatch, commit;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                state = _ref4.state, dispatch = _ref4.dispatch, commit = _ref4.commit;
                _context3.next = 3;
                return dispatch('d2admin/db/get', {
                  dbName: 'permission',
                  path: 'permission.menu',
                  defaultValue: [],
                  user: true
                }, {
                  root: true
                });

              case 3:
                state.menu = _context3.sent;
                dispatch('setMenu');

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};